<template>
    <el-dialog class="media-modal" :title="'选择'+text[activeName]" width="1200px" :visible.sync="showModal" top="5vh">
        <div class="search-box" v-if="activeName==1">
            <label>图文标题</label>
            <el-input placeholder="请输入图文标题" v-model="title" @keyup.enter.native="pageChange(1)"></el-input>
            <el-button class="add" type="warning" @click="pageChange(1)">查询</el-button>
        </div>
        <div class="article-panel" v-if="activeName==1">
            <div class="list1">
                <template v-for="(item,i) in list" >
                    <articleDetail :item="item" :key="i" v-if="i%4==0" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></articleDetail>
                </template>
            </div>
            <div class="list2">
                <template v-for="(item,i) in list" >
                    <articleDetail :item="item" :key="i" v-if="i%4==1" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></articleDetail>
                </template>
            </div>
            <div class="list3">
                <template v-for="(item,i) in list" >
                    <articleDetail :item="item" :key="i" v-if="i%4==2" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></articleDetail>
                </template>
            </div>
            <div class="list4">
                <template v-for="(item,i) in list" >
                    <articleDetail :item="item" :key="i" v-if="i%4==3" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></articleDetail>
                </template>
            </div>
        </div>
        <div class="img-panel" v-if="activeName==2">
            <div class="img-item" :class="{'active':item.id==selectData.id}" v-for="(item,i) in list" :key="i" @click="selectData=item">
                <div class="active-box">
                    <i class="icon-gouxuan"></i>
                </div>
                <div class="img-box">
                    <img :src="item.url">
                    <!-- <img src="@static/images/appcode.png" alt=""> -->
                </div>
                <div class="title">{{item.title}}</div>
            </div>
        </div>
        <div class="panel template-panel" v-if="activeName==3">
            <div class="list1">
                <template v-for="(item,i) in list">
                    <templateDetail :item="item" :key="i" v-if="i%4==0" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></templateDetail>
                </template>
            </div>
            <div class="list2">
                <template v-for="(item,i) in list">
                    <templateDetail :item="item" :key="i" v-if="i%4==1" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></templateDetail>
                </template>
            </div>
            <div class="list3">
                <template v-for="(item,i) in list">
                    <templateDetail :item="item" :key="i" v-if="i%4==2" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></templateDetail>
                </template>
            </div>
            <div class="list4">
                <template v-for="(item,i) in list">
                    <templateDetail :item="item" :key="i" v-if="i%4==3" type="select" :class="{'active':item.id==selectData.id}" @click.native="selectData=item"></templateDetail>
                </template>
            </div>
        </div>
        <el-pagination class="page" :current-page.sync='pageNum' background layout="total, prev, pager, next" @current-change="pageChange" :page-size='18' :total="listCount">
        </el-pagination>
        <div class="btn-list">
            <el-button type="warning" plain @click="showModal=false">返回</el-button>
            <el-button type="warning" @click="submit">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import articleDetail from "./articleDetail";
import templateDetail from "./templateDetail";
//当前实例组件
export default {
    props:{
        item:null,
        subscriptionId:"",
    },
    data: () => ({
        title:"",//标题搜索
        userId:"",
        text: {"1":"图文素材","2":"图片素材","3":"模板素材"},
        activeName:2,
        showModal:false,
        pageNum:1,
        listCount:0,
        list:[],
        selectData:{}
    }),
    components: {articleDetail,templateDetail},
    mounted() {
        this.userId = this.$tools.getLocal("userinfo").id
    },
    methods: {
        open(type){
            if(this.subscriptionId){
                this.selectData = {};
                this.activeName = type;
                this.pageNum = 1;
                this.getList();
            }else{
                this.$message.error('请选择公众号');
            }

        },
        close(){
            this.showModal = false;
        },
        submit(){
            if(this.selectData.id){
                this.showModal = false;
                this.$emit("submit",this.selectData);
            }else{
                this.$message.error('请选择'+this.text[this.activeName]);
            }
        },
        pageChange(page){
            this.pageNum = page;
            this.getList();
        },
        getList(){
            let ajaxUrl = "/wechatthirdplat/subscriptionMedia/read/list";
            let ajaxType = "post";
            const params = {
                userId: this.userId,
                pageSize:8,
                type:this.activeName,
                subscriptionId:this.subscriptionId,
                pageNum:this.pageNum
            }
            if(this.activeName == 3){
                ajaxUrl = "/wechatthirdplat/standardTemplate/read/customList";
                ajaxType = "put";
            }
            if(this.activeName == 2){
                params.pageSize = 18;
            }
            if(this.activeName == 1){
                params.title = this.title;
            }
            this.$http({
                url: ajaxUrl,
                type: ajaxType,
                params: params,
            }).then((data)=> {
                if(this.pageNum==1&&data.data.length==0){
                    this.$message.info("当前公众号暂无"+this.text[this.activeName]);
                    return;
                }
                this.showModal = true;
                if(this.activeName == 1){
                    data.data.forEach(item=>{
                        if(item.articles){
                            item.articles = JSON.parse(item.articles);
                        }
                        item.digest = item.articles[0].digest;
                        item.thumb_url = item.articles[0].thumb_url;
                        item.url = item.articles[0].url;
                    });
                }else if(this.activeName == 2){
                    data.data.forEach(item=>{
                        item.checked = false;
                    });
                }else if(this.activeName==3){
                    data.data.forEach(item=>{
                        if(item.color){
                            item.color = JSON.parse(item.color)
                        }else{
                            item.color = {};
                        }
                    });
                }

                this.list = data.data;
                this.listCount = data.total;
            })
        }
    },
};
</script>
<style lang="scss">
@import "./mediaModal";
</style>
